import { useMediaStore } from '@/store/pinia/media';
export default () => (to, from, next) => {
  const mediaStore = useMediaStore();
  if (!mediaStore.readinessSessionInitialized) {
    return next('/check');
  }
  return next();
};
